import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { getDocumentTitle } from '@/utils/getPageTitle';

export function DocumentTitle() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  useEffect(() => {
    document.title = getDocumentTitle(pathname);
  }, [pathname]);

  return null;
}
